import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { ArcLayer } from '@deck.gl/layers';
var GreatCircleLayer = function (_ArcLayer) {
  _inherits(GreatCircleLayer, _ArcLayer);
  function GreatCircleLayer() {
    _classCallCheck(this, GreatCircleLayer);
    return _possibleConstructorReturn(this, _getPrototypeOf(GreatCircleLayer).apply(this, arguments));
  }
  return GreatCircleLayer;
}(ArcLayer);
export { GreatCircleLayer as default };
GreatCircleLayer.layerName = 'GreatCircleLayer';
GreatCircleLayer.defaultProps = {
  getHeight: {
    type: 'accessor',
    value: 0
  },
  greatCircle: true
};
//# sourceMappingURL=great-circle-layer.js.map